const getters = {
    user: state => state.user.info,
    token: state => state.user.token,
    hadAddRoutes: state => state.user.hadAddRoutes,
    roles: state => state.user.roles,
    addRouters: state => state.permission.addRouters,
    isAdmin: state => state.user.isAdmin,
    IsLevel2AuditAuth: state => state.user.IsLevel2AuditAuth,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js